
import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import FavoriteButton from "@/components/common/FavoriteButton";

interface TestCardProps {
  id: string;
  title: string;
  description: string;
  icon: string;
  onSelectTest: (testId: string) => void;
}

const TestCard: React.FC<TestCardProps> = ({ 
  id, 
  title, 
  description, 
  icon, 
  onSelectTest 
}) => {
  const { t } = useTranslation('training');
  return (
    <Card className="border border-gray-200 shadow-sm transition-all duration-200 hover:shadow-md overflow-hidden">
      <CardContent className="p-4 pb-2">
        <div className="flex justify-between items-start mb-2">
          <div className="flex items-start gap-2">
            <h3 className="text-lg font-medium text-golf-800">{title}</h3>
            <span className="text-2xl" aria-hidden="true">{icon}</span>
          </div>
          <FavoriteButton 
            testId={id} 
            testType="level1"
            size="icon"
            variant="ghost"
          />
        </div>
        <p className="text-sm text-golf-600 mb-4">{description}</p>
      </CardContent>
      <CardFooter className="pt-0 p-4">
        <Button 
          onClick={() => onSelectTest(id)} 
          className="w-full bg-golf-600 hover:bg-golf-700"
        >
          {t('level1.interface.selectButton')}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default TestCard;
